<template>
  <div class="uk-flex-center uk-margin-medium-top" uk-grid>
    <div class="uk-width-2-3@l">
      <BitInvoice
      :full_name="full_name"
      :address="address"
      :city="city"
      :state="state"
      :zip="zip"
      :country="country"
      :number="invoice.id"
      :due_date="invoice.date_due"
      :total="invoice.total"
      :line_items="invoice.line_items"
      >
      </BitInvoice>
    </div>
  </div>
</template>

<script>
import BitInvoice from '@/components/portal/invoice.vue'

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: 'ViewInvoice',
  components: {
    BitInvoice,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters('user', ['full_name']),
    ...mapGetters('invoices', ['getInvoiceById']),
    ...mapState('user', ['address', 'city', 'state', 'zip', 'country']),
    ...mapState('invoices', ['invoices']),
    invoice() {
      return this.getInvoiceById(this.$route.params.id);
    }
  },
  created() {
    this.GET_INVOICE(this.$route.params.id);
  },
  methods: {
    ...mapActions('invoices', ['GET_INVOICE'])
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/less/theme.less";

</style>
